import { render } from "./MainPanel.vue?vue&type=template&id=58006f01&scoped=true"
import script from "./MainPanel.vue?vue&type=script&lang=js"
export * from "./MainPanel.vue?vue&type=script&lang=js"

import "./MainPanel.vue?vue&type=style&index=0&id=58006f01&scoped=true&lang=css"

import exportComponent from "C:\\Qedtek Project\\Takayama-New\\takayama_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58006f01"]])

export default __exports__